import React, { useState, useEffect } from 'react';

import Select from 'react-select';

import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import countries from '../resources/countries.json';
import period from '../../../resources/dedicationPeriod.json';
import resource from '../resources/resource.json';

import { getCartState } from '@msdyn365-commerce/global-state';
import { SimpleProduct, AsyncResult } from '@msdyn365-commerce/retail-proxy';

import { deleteBTGPCartLineAsync, getAllBTGPCartLineAsync } from '../../../actions/DataActionExtension.g';

import { IField, IdState } from '../ecomm-product-details-form.data';
import { IEcommProductDetailsFormConfig } from '../ecomm-product-details-form.props.autogenerated';

interface IEcommFormProps {
  formScheme: IField[];
  selectedProduct: AsyncResult<SimpleProduct>;
  rowsData: IdState[];
  addRow(noOfRows: Number): void;
  deleteRow(idx: number): void;
  callbackMultiplier: any;
  callbackDedicationPeriod: any;
  callbackName?: any;
  callbackCompanyName: any;
  callbackBuilding: any;
  callbackUnitNumber: any;
  callbackPostalCode: any;
  callbackCountry: any;
  callbackNamesEntered?: any;
  callbackCompaniesEntered: any;
  callbackAddressEntered: any;
  formItems: [];
  config: IEcommProductDetailsFormConfig;
  localeCode: string;
  actionContext: any;
  userInfo: any;
  isMobile: boolean;
  isEditMode: boolean;
  allowMultipleRegistrations: boolean;
}

const ServicesBusinessForm: React.FC<IEcommFormProps> = ({
  formScheme, selectedProduct, rowsData, addRow, deleteRow,
  callbackMultiplier, callbackDedicationPeriod, callbackName, callbackCompanyName,
  callbackBuilding, callbackUnitNumber, callbackPostalCode, callbackCountry,
  callbackNamesEntered, callbackCompaniesEntered, callbackAddressEntered,
  formItems, config, localeCode, actionContext, userInfo, isMobile, isEditMode, allowMultipleRegistrations }) => {
  const [dedicationPeriod, setDedicationPeriod] = useState([period[`${localeCode}`].period[0].label]);
  const [ceremonyName, setCeremonyName] = useState(['']);
  const [companyName, setCompanyName] = useState(['']);
  const [buildingName, setBuildingName] = useState(['']);
  const [unitNumber, setUnitNumber] = useState(['']);
  const [postalCode, setPostalCode] = useState(['']);
  const [countryName, setCountry] = useState(['']);

  const [multipliers, setMultiplers] = useState([1]);

  const formLabels = resource.servicesBusinessForm[`${localeCode}`];
  const userValid = (userInfo && userInfo.emailaddress1) ? userInfo.emailaddress1.trim() !== '' : false;

  const onSubmit = (data: any) => {
    // display form data on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(data, null, 4));
  }

  // Functions to build form returned by useForm() hook.
  const { handleSubmit, reset } = useForm();

  const _setMultipler = (periodLabel: string, index: number) => {
    const valueArray = multipliers.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push(period.scale[0]);
    }

    const scaleIdx = period[`${localeCode}`].period.findIndex((item: { value: number; label: string; }) => item.label === periodLabel);

    valueArray[`${index}`] = period.scale[`${scaleIdx}`];

    setMultiplers(valueArray);

    callbackMultiplier(valueArray);
  }

  const _setDedicationPeriod = (event: any, index: number) => {
    const valueArray = dedicationPeriod.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push(period[`${localeCode}`].period[0].label);
    }

    valueArray[`${index}`] = event.label;

    setDedicationPeriod(valueArray);

    callbackDedicationPeriod(valueArray);

    _setMultipler(event.label, index);
  }

  const _setNameInputValue = (event: any, index: number) => {
    let maxLength = config.charactersLimitForNames ? config.charactersLimitForNames : 31;

    _setCeremonyNameArray(event.target.value.substring(0, maxLength - 1), index);
  }

  const _setCeremonyNameArray = (name: string, index: number) => {
    const valueArray = ceremonyName.slice();

    // To handle adding of a new form record.
    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    valueArray[`${index}`] = name;

    valueArray[`${index}`].trim();

    setCeremonyName(valueArray);

    callbackName(valueArray);

    _checkNameEntered(valueArray);
  }

  const _setCompanyName = (name: string, index: number) => {
    const valueArray = companyName.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    valueArray[`${index}`] = name;

    valueArray[`${index}`].trim();

    setCompanyName(valueArray);

    callbackCompanyName(valueArray);

    _checkCompanyEntered(valueArray);
  }

  const _setBuildingName = (value: string, index: number) => {
    const valueArray = buildingName.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    valueArray[`${index}`] = value;

    valueArray[`${index}`].trim();

    setBuildingName(valueArray);

    callbackBuilding(valueArray);

    _checkAddressEntered(buildingName, postalCode);
  }

  const _setUnitNumber = (value: string, index: number) => {
    const valueArray = unitNumber.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    valueArray[`${index}`] = value;

    valueArray[`${index}`].trim();

    setUnitNumber(valueArray);

    callbackUnitNumber(valueArray);
  }

  const _setPostalCode = (value: string, index: number) => {
    const valueArray = postalCode.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    if(value.length<=6){
      valueArray[`${index}`] = value;
    }else{
      toast.warning(resource.invalidPostalCodeMessage[`${localeCode}`]);
    }

    valueArray[`${index}`].trim();

    setPostalCode(valueArray);

    callbackPostalCode(valueArray);

    _checkAddressEntered(buildingName, postalCode);
  }

  const _setCountry = (event: any, index: number) => {
    const valueArray = countryName.slice();

    while (typeof valueArray[`${index}`] === 'undefined') {
      valueArray.push('');
    }

    valueArray[`${index}`] = event.label;

    setCountry(valueArray);

    callbackCountry(valueArray);
  }

  const _displayDedicationPeriod = (index: number): { value: string, label: string } => {
    if (dedicationPeriod.length > 0) {
      const selectValueArray = dedicationPeriod.slice();

      if (typeof selectValueArray[`${index}`] !== 'undefined') {
        return period[`${localeCode}`].period.find((item: { value: string, label: string }) => item.label === selectValueArray[`${index}`]);
      }
    }

    return { value: '', label: '' };
  }

  const _checkNameEntered = (valueArray: string[]) => {
    let checked = true;

    for (let i = 0; i < valueArray.length; i++) {
      if (valueArray[`${i}`].replace(/;/g, '').trim() === '') {
        checked = false; break;
      }
    }

    callbackNamesEntered(checked);
  }

  const _checkCompanyEntered = (valueArray: string[]) => {
    let checked = true;

    for (let i = 0; i < valueArray.length; i++) {
      if (valueArray[`${i}`].replace(/;/g, '').trim() === '') {
        checked = false; break;
      }
    }

    callbackCompaniesEntered(checked);
  }

  const _checkAddressEntered = (buildingArray: string[], postalCodeArray: string[]) => {
    let result = true;

    for (let i = 0; i < buildingArray.length; ++i) {
      result = result && buildingArray[`${i}`] !== '' && postalCodeArray[`${i}`] !== '';
    }

    callbackAddressEntered(result);
  }

  const _initBuildingField = () => {
    if (userValid) {
      return userInfo.gmb_blockno.trim() + (userInfo.gmb_buildingno !== '' ? ', ' + userInfo.gmb_buildingno.trim() : '') + (userInfo.gmb_buildingname !== '' ? ', ' + userInfo.gmb_buildingname.trim() : '') + (userInfo.address1_line1 !== '' ? ', ' + userInfo.address1_line1.trim() : '') + (userInfo.address1_city !== '' ? ', ' + userInfo.address1_city.trim() : '');
    }

    return '';
  }

  const _initCountryField = () => {
    if (userValid) {
      const states = countries[`${localeCode}`].countries;

      const location = states.find((place: { value: string, label: string }) => place.label.toUpperCase() === userInfo.address1_country.toUpperCase());

      return location ? location.label : '';
    }

    return '';
  }

  const _addItem = () => {
    addRow(1);

    const multiplierArray = multipliers.slice();
    const dedicationPeriodArray = dedicationPeriod.slice();
    const ceremonyNameArray = ceremonyName.slice();
    const companyNameArray = companyName.slice();
    const buildingNameArray = buildingName.slice();
    const unitNumberArray = unitNumber.slice();
    const postalCodeArray = postalCode.slice();
    const countryArray = countryName.slice();

    multiplierArray.push(period.scale[0]);
    dedicationPeriodArray.push(period[`${localeCode}`].period[0].label);
    ceremonyNameArray.push('');
    companyNameArray.push('');

    if (userValid) {
      buildingNameArray.push(_initBuildingField());
      unitNumberArray.push(userInfo.gmb_unitnofloorapartmentno);
      postalCodeArray.push(userInfo.address1_postalcode);
      countryArray.push(_initCountryField());
    } else {
      buildingNameArray.push('');
      unitNumberArray.push('');
      postalCodeArray.push('');
      countryArray.push(countries[`${localeCode}`].countries[0].label);
    }

    setMultiplers(multiplierArray);
    setDedicationPeriod(dedicationPeriodArray);
    setCeremonyName(ceremonyNameArray);
    setCompanyName(companyNameArray);
    setBuildingName(buildingNameArray);
    setUnitNumber(unitNumberArray);
    setPostalCode(postalCodeArray);
    setCountry(countryArray);

    callbackMultiplier(multiplierArray);
    callbackDedicationPeriod(dedicationPeriodArray);
    callbackName(ceremonyNameArray);
    callbackCompanyName(companyNameArray);
    callbackBuilding(buildingNameArray);
    callbackUnitNumber(unitNumberArray);
    callbackPostalCode(postalCodeArray);
    callbackCountry(countryArray);

    callbackNamesEntered(false);
    callbackCompaniesEntered(false);

    _checkAddressEntered(buildingName, postalCode);
  }

  const _deleteCartLine = async (index: number): Promise<void> => {
    if (typeof formItems[`${index}`] !== 'undefined') {
      const cartState = await getCartState(actionContext);

      let success = false;

      const cartItems = await getAllBTGPCartLineAsync({ callerContext: actionContext }, cartState.cart.Id);

      if (cartItems.length > 0) {
        let removeCartLinesResult = await cartState.removeCartLines({ cartLineIds: [formItems[`${index}`]['cartLineId']] });

        if (removeCartLinesResult.status === 'SUCCESS') {
          success = true;
        }

        let deleteCartLineResult = await deleteBTGPCartLineAsync({ callerContext: actionContext }, formItems[`${index}`]['cartLineId']);

        if (success && deleteCartLineResult) {
          deleteRow(index);
          formItems.splice(index, 1);
          _updateStateData(index);
        }

      } else {
        deleteRow(index);
        _updateStateData(index);
      }
    } else {
      deleteRow(index);
      _updateStateData(index);
    }
  }

  const _updateStateData = (index: number) => {
    const multiplierArray = multipliers.slice();
    const dedicationPeriodArray = dedicationPeriod.slice();
    const ceremonyNameArray = ceremonyName.slice();
    const companyNameArray = companyName.slice();
    const buildingNameArray = buildingName.slice();
    const unitNumberArray = unitNumber.slice();
    const postalCodeArray = postalCode.slice();
    const countryArray = countryName.slice();

    if (typeof multiplierArray[`${index}`] !== 'undefined') {
      if (multiplierArray.length > 1) {
        multiplierArray.splice(index, 1);
      } else {
        multiplierArray[0] = period.scale[0];
      }

      setMultiplers(multiplierArray);

      callbackMultiplier(multiplierArray);
    }

    if (typeof dedicationPeriodArray[`${index}`] !== 'undefined') {
      if (dedicationPeriodArray.length > 1) {
        dedicationPeriodArray.splice(index, 1);
      } else {
        dedicationPeriodArray[0] = period[`${localeCode}`].period[0].label;
      }

      setDedicationPeriod(dedicationPeriodArray);

      callbackDedicationPeriod(dedicationPeriodArray);
    }

    if (typeof ceremonyNameArray[`${index}`] !== 'undefined') {
      if (ceremonyNameArray.length > 1) {
        ceremonyNameArray.splice(index, 1);
      } else {
        ceremonyNameArray[0] = '';
      }

      setCeremonyName(ceremonyNameArray);

      callbackName(ceremonyNameArray);
    }

    if (typeof companyNameArray[`${index}`] !== 'undefined') {
      if (companyNameArray.length > 1) {
        companyNameArray.splice(index, 1);
      } else {
        companyNameArray[0] = '';
      }

      setCompanyName(companyNameArray);

      callbackCompanyName(companyNameArray);
    }

    if (typeof buildingNameArray[`${index}`] !== 'undefined') {
      if (buildingNameArray.length > 1) {
        buildingNameArray.splice(index, 1);
      } else {
        buildingNameArray[0] = '';
      }

      setBuildingName(buildingNameArray);

      callbackAddressEntered(buildingNameArray);
    }

    if (typeof unitNumberArray[`${index}`] !== 'undefined') {
      if (unitNumberArray.length > 1) {
        unitNumberArray.splice(index, 1);
      } else {
        unitNumberArray[0] = '';
      }

      setUnitNumber(unitNumberArray);

      callbackUnitNumber(unitNumberArray);
    }

    if (typeof postalCodeArray[`${index}`] !== 'undefined') {
      if (postalCodeArray.length > 1) {
        postalCodeArray.splice(index, 1);
      } else {
        postalCodeArray[0] = '';
      }

      setPostalCode(postalCodeArray);

      callbackPostalCode(postalCodeArray);
    }

    if (typeof countryArray[`${index}`] !== 'undefined') {
      if (countryArray.length > 1) {
        countryArray.splice(index, 1);
      } else {
        countryArray[0] = countries[`${localeCode}`].countries[0].label;
      }

      setCountry(countryArray);

      callbackCountry(countryArray);
    }

    _checkNameEntered(ceremonyNameArray);
    _checkCompanyEntered(companyNameArray);
    _checkAddressEntered(buildingName, postalCode);
  }

  useEffect(() => {
    const existingMultiplier: number[] = [];
    const existingDedicatedPeriod: string[] = [];
    const existingCeremonyName: string[] = [];
    const existingCompanyName: string[] = [];
    const existingBuildingName: string[] = [];
    const existingUnitNumber: string[] = [];
    const existingPostalCode: string[] = [];
    const existingCountry: string[] = [];

    if (formItems.length > 0) {
      for (let i = 0; i < formItems.length; i++) {
        const selectedPeriod = formItems[`${i}`]['dedicationPeriod'] !== '' ? formItems[`${i}`]['dedicationPeriod'] : period[`${localeCode}`].period[0].label;
        const index = period[`${localeCode}`].period.findIndex((item: { value: number; label: string; }) => item.label === selectedPeriod);

        existingMultiplier.push(period.scale[`${index}`]);
        existingDedicatedPeriod.push(selectedPeriod);
        existingCeremonyName.push(formItems[`${i}`]['names'][0]);
        existingCompanyName.push(formItems[`${i}`]['companyName']);
        existingBuildingName.push(formItems[`${i}`]['buildingName']);
        existingUnitNumber.push(formItems[`${i}`]['unitNumber']);
        existingPostalCode.push(formItems[`${i}`]['postalCode']);
        existingCountry.push(formItems[`${i}`]['country']);
      }

      setMultiplers(existingMultiplier);
      setDedicationPeriod(existingDedicatedPeriod);
      setCeremonyName(existingCeremonyName);
      setCompanyName(existingCompanyName);
      setBuildingName(existingBuildingName);
      setUnitNumber(existingUnitNumber);
      setPostalCode(existingPostalCode);
      setCountry(existingCountry);

      callbackMultiplier(existingMultiplier);
      callbackDedicationPeriod(existingDedicatedPeriod);
      callbackName(existingCeremonyName);
      callbackCompanyName(existingCompanyName);
      callbackBuilding(existingBuildingName);
      callbackUnitNumber(existingUnitNumber);
      callbackPostalCode(existingPostalCode);
      callbackCountry(existingCountry);

      _checkNameEntered(existingCeremonyName);
      _checkCompanyEntered(existingCompanyName);
      _checkAddressEntered(existingBuildingName, existingPostalCode);
    } else {
      if (userValid) {
        existingBuildingName.push(_initBuildingField());
        existingUnitNumber.push(userInfo.gmb_unitnofloorapartmentno);
        existingPostalCode.push(userInfo.address1_postalcode);
        existingCountry.push(_initCountryField());

        setBuildingName(existingBuildingName);
        setUnitNumber(existingUnitNumber);
        setPostalCode(existingPostalCode);
        setCountry(existingCountry);

        callbackBuilding(existingBuildingName);
        callbackUnitNumber(existingUnitNumber);
        callbackPostalCode(existingPostalCode);
        callbackCountry(existingCountry);

        _checkAddressEntered(existingBuildingName, existingPostalCode);
      }

      callbackDedicationPeriod(dedicationPeriod);
    }
  }, [formItems]);

  const _buildDedicationPeriod = (idx: number): JSX.Element | null => {
    return (
      <div className='row'>
        <div className='col-lg-4 form-field'>
          <p className='form-label'>{formLabels.dedicationPeriod}</p>
          <Select
            value={_displayDedicationPeriod(idx)}
            options={period[`${localeCode}`].period}
            onChange={(event: any) => _setDedicationPeriod(event, idx)}
            className={'select'}
            isSearchable={false}
          />
        </div>
      </div>
    );
  }

  const _buildNameField = (idx: number): JSX.Element => {
    return (
      <div className='row'>
        <div className='col-lg-4 form-field'>
          <p className='form-label'>{formLabels.name}</p>
          <input
            type='text'
            inputMode='text'
            value={ceremonyName[`${idx}`]}
            aria-live='polite'
            role='spinbutton'
            onChange={(event: any) => _setNameInputValue(event, idx)}
            onKeyDown={(event) => { if (event.keyCode === 13) { event.preventDefault(); } }}
            className='form-control'
            maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
            autoComplete="none"
          />
        </div>
      </div>
    );
  }

  const _buildCompanyField = (idx: number): JSX.Element => {
    return (
      <div className='row'>
        <div className='col-lg-6 form-field'>
          <p className='form-label'>{formLabels.companyName}</p>
          <input
            type='text'
            inputMode='text'
            value={companyName[`${idx}`]}
            aria-live='polite'
            role='spinbutton'
            onChange={(event: any) => _setCompanyName(event.target.value, idx)}
            onKeyDown={(event) => { if (event.keyCode === 13) { event.preventDefault(); } }}
            className='form-control'
            maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
            autoComplete="none"
          />
        </div>
      </div>
    );
  }

  const _buildAddressField = (idx: number): JSX.Element => {
    const states = countries[`${localeCode}`].countries;

    return (
      <div className='row'>
        <p className='col-12 prompt'>{formLabels.addressPrompt}</p>
        <div className='col-lg-6 form-field'>
          <p className='form-label'>{formLabels.addressBuilding}</p>
          <input
            aria-live='polite'
            className='form-control'
            inputMode='text'
            role='spinbutton'
            onChange={(event: any) => _setBuildingName(event.target.value, idx)}
            onKeyDown={(event) => { if (event.keyCode === 13) { event.preventDefault(); } }}
            maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
            value={buildingName[`${idx}`]}
            type='text'
            autoComplete="none"
          />

          <p className='form-label'>{formLabels.addressUnit}</p>
          <input
            aria-live='polite'
            className='form-control'
            inputMode='text'
            role='spinbutton'
            onChange={(event: any) => _setUnitNumber(event.target.value, idx)}
            onKeyDown={(event) => { if (event.keyCode === 13) { event.preventDefault(); } }}
            maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
            value={unitNumber[`${idx}`]}
            type='text'
            autoComplete="none"
          />
        </div>

        <div className='col-lg-10 row'>
          <div className='col-lg-4 form-field'>
            <p className='form-label'>{formLabels.addressPostalCode}</p>
            <input
              type='text'
              inputMode='text'
              value={postalCode[`${idx}`]}
              aria-live='polite'
              role='spinbutton'
              onChange={(event: any) => _setPostalCode(event.target.value, idx)}
              onKeyDown={(event) => { if (event.keyCode === 13) { event.preventDefault(); } }}
              className='form-control'
              autoComplete="none"
            />
          </div>

          <div className='col-lg-5 offset-lg-1 form-field'>
            <p className='form-label'>{formLabels.addressCountry}</p>
            <Select
              placeholder={countryName[`${idx}`]}
              options={states}
              onChange={(event: any) => _setCountry(event, idx)}
              className={'select'}
              isSearchable={true}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='ecomm-purchase-form'>
      <form onSubmit={handleSubmit(onSubmit)} onReset={reset} autoComplete='off'>
        <div className='ecomm-purchase-form-table'>
          {rowsData.map((i, idx) => {
            return (
              <div className='form-record'>
                <div key={`row${i.id}`} className='form-details row'>
                  {formScheme.map((element: IField, index: number) => {

                    if (element.field_name === 'period') {
                      return (
                        <div className='form-details-item col-lg-9'>
                          {_buildDedicationPeriod(idx)}
                          {_buildNameField(idx)}
                          {_buildCompanyField(idx)}
                          {_buildAddressField(idx)}
                        </div>
                      );
                    }

                    if (!isMobile && element.field_type === 'product_price') {
                      return (
                        <div className='form-details-item bordered centred col-2'>
                          <p key={index} className='subtotal'>${multipliers[`${idx}`] * selectedProduct.result?.Price!}</p>
                        </div>
                      );
                    }

                    if (element.field_type === 'action') {
                      if (isMobile) {
                        const style = !isEditMode ? 'form-details-item' : 'form-details-item edit';

                        return (
                          <div className={style}>
                            {!isEditMode && allowMultipleRegistrations && <div className='col-10'>
                              <button className='add-row' type='submit' onClick={_addItem}>{resource.addAnotherItemTitle[`${localeCode}`]}</button>
                            </div>}
                            <div className='delete-wrapper col-2'><button className={element.action} onClick={() => _deleteCartLine(idx)} /></div>
                          </div>
                        );
                      }

                      return (
                        <div className='form-details-item centred col-sm-1'>
                          <button className={element.action} onClick={() => _deleteCartLine(idx)} />
                        </div>
                      );
                    }

                    return;
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {!isMobile && !isEditMode && allowMultipleRegistrations &&
          <div className='ecomm-purchase-form-add'>
            <button type='submit' onClick={_addItem}>{resource.addAnotherItemTitle[`${localeCode}`]}</button>
          </div>}
      </form>
    </div>
  );
};

export default ServicesBusinessForm